import React, { Component } from 'react';
import Fade from './Fade.js';

import {CreateWidgetChooseSocialNetwork} from './CreateWidgetChooseSocialNetwork';
import {SenderVarsPage} from './SenderVarsPage';
import {SenderRedMessagePage} from './SenderRedMessagePage';
import axios from 'axios';
import Cookies from 'universal-cookie';
import MainHeaderUnderline from './MainHeaderUnderline';
import VkLogo from './vk_logo.png';
import TgLogo from './TgLogo.png';
import ReactPaginate from 'react-paginate';
import Select from 'react-select';
import ActiveIconSecond from './ActiveIconSecond';
import {Loader} from './Loader';
import NoPhoto from './no_photo.jpg';
import LinesEllipsis from 'react-lines-ellipsis'
import MailingSuccessIcon from './MailingSuccessIcon';
import MailingPauseIcon from './MailingPauseIcon';
import MailingErrorIcon from './MailingErrorIcon';


export class MailingPage extends React.Component {

    onOnePage = 5
    options_vars = {
        'tg' : { value: 'tg', label: <img src={TgLogo} height="30px" width="30px" /> },
        'vk' : { value: 'vk', label: <img src={VkLogo} height="30px" width="30px" /> },
    }
    options = [
        { value: 'tg', label: <img src={TgLogo} height="30px" width="30px" /> },
        { value: 'vk', label: <img src={VkLogo} height="30px" width="30px" /> },
    ]
    state = {
       
        items : [],
        onOnePage : this.onOnePage,
        limit: this.onOnePage,
        offset: 0,
        page_count: 0,
        selectedOption : this.options_vars['vk'],
        social: 'vk',
        isLoading: false
    }

    handleChange = (social) => {
       
        this.setState((prevState) => {
          return  {
                 ...prevState,
                 
                 social : social,
                 isLoading: true
             };
     }, () =>  {
        window.location.hash = this.state.social;
        const cookies = new Cookies();

        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/GetMailingList?social='+this.state.social+'&limit='+this.state.onOnePage+'&offset='+this.state.offset,
        
        {
                    headers: {

                    'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                    }
                }).then(res => {
                        
                         
                        var page_count = Math.ceil( res.data.numberMailing / this.state.onOnePage )
                        this.setState( {
                            isLoading: false,
                            items : res.data.res,
                            page_count : page_count
                        });
                })
                .catch(err => {
                    console.log(err);
                    this.setState( {
                        isLoading: false
                    });

                }) 
     })  
      };
      
    constructor(props) {
        super(props);
        //console.log(this.props.data)
        this.handlePageClick = this.handlePageClick.bind(this)
        
    }

    componentWillMount() {
        var url = window.location.href.split('/')[3]
        var social = url.split('#')[1]
        if (social == undefined) {
            social = 'tg'
        }
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   selectedOption : this.options_vars[social],
                   social : social
               };
       }, () =>  {

        const cookies = new Cookies();
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/GetMailingList?social='+this.state.social+'&limit='+this.state.onOnePage+'&offset='+this.state.offset,
        
        {
                    headers: {

                    'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                    }
                }).then(res => {
                        
                         
                        var page_count = Math.ceil( res.data.numberMailing / this.state.onOnePage )
                        this.setState( {
                            
                            items : res.data.res,
                            page_count : page_count
                        });
                })
                .catch(err => {
                    console.log(err);
                    

                })

       })
        
        
        
        
        

    }
  
  
    deleteMailing(e, mailing_id) {

        const cookies = new Cookies();
        axios.post(process.env.REACT_APP_BACKEND_SERVER + '/DeleteMailing/',
        {
            mailing_id : mailing_id
        }, {
                    headers: {
                    'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                    }
                }).then(res => {
                    
                    if (res.data.status == 'ok') {
                        window.location.hash = "#" + this.state.social;
                        window.location.reload(true);
                    }
                })
                .catch(err => {
                    console.log(err);
                    

                })


    }

    handlePageClick(e) {
        var page = e.selected + 1 
        this.setState({
            isLoading: true
        })
        const cookies = new Cookies();
        var offset = (page - 1) * this.state.onOnePage
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/GetMailingList?social='+this.state.social+'&limit='+this.state.onOnePage+'&offset='+offset,
        
        {
                    headers: {

                    'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                    }
                }).then(res => {
                        
                        this.setState( {
                            
                            items : res.data.res,
                            isLoading: false
                        });
                })
                .catch(err => {
                    console.log(err);
                    

                })
        
    }

    startSender(e, id) {

        const cookies = new Cookies()
        
        
        axios
            .post(process.env.REACT_APP_BACKEND_SERVER+'/StartSender/', {
                
                'mailing_id' : id
                
            }, {
                headers : {
                    'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                }
            } )
            .then(res => {
                if (res.data.status == 'ok') {
                    window.location.href = '/mailingstats/'+id
                }
            })
            .catch(err => {
            console.log(err);
            })


    }
    
    render() {
        return (
            <div className='createPage'>
                <Loader loader={this.state.isLoading} />
                <div className='createPageTitle'>
                <h1> Созданные рассылки</h1>
                <MainHeaderUnderline />
                </div>
               
               
                
                <div className='mailingPageSelectSocial chooseNetworkBlock_block_blocks '>
                
                <div className='chooseNetworkBlock_block' onClick={ () =>  {
                    this.handleChange("vk")
                }}>
                    <div className='chooseNetworkBlock_block_activated'>{
                        this.state.social == 'vk' ? <ActiveIconSecond /> : null

                    } </div>
                    <img src={VkLogo} />
                    <div className='chooseNetworkBlock_block_name'>
                        Вконтакте
                    </div>
                    
                </div>
                

                <div className='chooseNetworkBlock_block'  onClick={ () =>  {
                    this.handleChange("tg")
                }}>
                    
    
                    <div className='chooseNetworkBlock_block_activated'>{
                        this.state.social == 'tg' ? <ActiveIconSecond /> : null

                    }</div>
                    <img src={TgLogo} />
                    <div className='chooseNetworkBlock_block_name'>
                        Телеграм
                    </div>
                    
                </div>

                {/*<Select
        option={this.state.selectedOption}
        defaultValue={this.state.selectedOption}
        onChange={this.handleChange}
        options={this.options}/>*/} 
                </div>
                

                <div className="mailingPage__pagination">

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="Далее>"
                    onPageChange={this.handlePageClick}
                    pageRangeDisplayed={1}
                    marginPagesDisplayed={1}
                    containerClassName={"pagination"}
                    pageClassName={"pagination_item"}
                    pageLinkClassName={"pagination_item_link"}
                    previousClassName={"pagination_item_prev"}
                    nextClassName={"pagination_item_next"}
                    breakClassName={"pagination_item"}
                    activeClassName={"pagination_item_active"}
                    pageCount={this.state.page_count}
                    previousLabel="<Назад"
                    renderOnZeroPageCount={null}
                />
                </div>

                {this.state.items.length > 0 ? 
                 <table className="mailingTable">
                 <tr>
                     <th className='firstColumnTh'>Рассылка</th>
                     <th className='secondColumnTh'>Инфо</th>
                     <th className='thirdColumnTh'>Статус</th>
                     <th className='fourthColumnTh'>Дата</th>
                     <th className='fifthColumnTh'>Редакция</th>

                 </tr>
                 {
                     this.state.items.map(item => {
                         return (
                     <tr>
                     <td  className='firstColumnTd'>
                             <div className="table_img">
                                 <img src={item.photo ? item.photo : NoPhoto} />
                             </div>
                             <div className="table_mainContent">
                                 <div className='table_mainContent_name'>
                                < LinesEllipsis
text={item.name}
maxLine='1'
ellipsis='...'
trimRight
basedOn='letters'
/>
</div>
                                 <div className='table_mainContent_text'><LinesEllipsis
text={item.text}
maxLine='2'
ellipsis='...'
trimRight
basedOn='letters'
/></div>
                             </div>
                     </td>
                     <td  className='secondColumnTd'>
                         
                         <div className='table_mainContent_text'>
                      <span className='tableTextHighlight'>{item.count_messages_to_send}</span> сообщен(ий) 
                      {this.state.social == 'tg' ? <span> в боте <span className='tableTextHighlight'>{item.bot_name}</span></span> : null} 
                      {this.state.social == 'vk' ? <span> в группе <span className='tableTextHighlight'><a target="_blank" className='tableLink' href={item.vk_group_link}>{item.vk_group_link}</a></span></span> : null} 
                          
                         </div>
                     </td>
                     <td className='thirdColumnTd'>
                         
                         {item.mailing_status == 'not began' ? <MailingPauseIcon /> : null}
                         {item.mailing_status == 'all successful' ? <MailingSuccessIcon /> : null}
                         { item.mailing_status == 'not all successful' ? <MailingErrorIcon /> : null}
                     </td>
                     <td>
                         <div className="table_date">
                         {item.date.split(' ')[0]}

                             </div>
                             <div className="table_time">
                         {item.date.split(' ')[1]}

                             </div>
                     </td>
                     <td className='fifthColumnTd'>
                         <a onClick={(e) => {
                                                 this.startSender(e, item.id)
                                             }} className='table_btn1 table_btn' href='#'>Запустить</a>
                         <a className='table_btn1 table_btn'   href={'/mailingstats/'+item.id}>Статистика</a>
                         <a onClick={(e) => {
                                                 if(window.confirm("Вы уверены, что хотите удалить рассылку?")) { 
                                                     this.deleteMailing(e, item.id)
                                                 }
                                             }} className='table_btn2 table_btn' href='#'>Удалить</a>
                     </td>
                     </tr> )   
                 
                 })}
             </table> 
                :
                 <h3 className='notCreatedText' style={{marginTop: '3.5em'}}>Пока нет созданных рассылок</h3>}           
               

                {/*  <div className='mailingPageMainBlock'>
                                {
                                    this.state.items.map(item => {
                                    return (
                                        <div className='mailingPageMainBlock_mailingRow'>
                                            <div>
                                                {item.mailing_status}
                                            </div>
                                            <div className='mailingPageMainBlock_mailingRow_link' >
                                                {item.bot_name}
                                            </div>
                                            <div className='mailingPageMainBlock_mailingRow_logo' >
                                                {item.social == 'vk' ? <img src={VkLogo} /> : null }
                                                {item.social == 'tg' ? <img src={TgLogo} /> : null }
                                            </div>

                                            <div className='mailingPageMainBlock_mailingRow_cntMsg'>
                                                Отправялем {item.count_messages_to_send} сообщений
                                            </div>
                                            <div  className='mailingPageMainBlock_mailingRow_msgText'>
                                                {item.text}
                                            </div>
                                            <div  className='mailingPageMainBlock_mailingRow_msgPhoto'>
                                                <img src={item.photo} />
                                            </div>
                                            <div  className='mailingPageMainBlock_mailingRow_buttonBlock'>
                                                <a onClick={(e) => {
                                                    this.startSender(e, item.id)
                                                }} className='btn1' href='#'>
                                                    Запустить рассылку
                                                </a>
                                                <a className='btn1' href='#' onClick={(e) => {
                                                    if(window.confirm("Вы уверены, что хотите удалить рассылку?")) { 
                                                        this.deleteMailing(e, item.id)
                                                    }
                                                }}>
                                                    Удалить рассылку
                                                </a>
                                                <a className='btn1' href={'/mailingstats/'+item.id}>
                                                    Статистика
                                                </a>
                                            </div>
                                            <hr></hr>
                                        </div>
                                    );
                                    })
                                }
                                </div> */}
              
                
               
            </div>
                 
        )
    }
    
}